import React from "react";
import "./App.css";
import DatabaseSearchPage from "./pages/DatabaseSearch";
import HomePage from "./pages/HomePage";
import ApplicationBar from "./components/ApplicationBar";
import FAQPage from "./pages/FAQ";
import ToolboxPage from "./pages/KHToolbox";
import APIWebReferenceReferencePage from "./pages/APIWebReferenceReference";
import APIWebReferenceOverviewPage from "./pages/APIWebReferenceOverview";
import GettingStartedPage from "./pages/KHGettingStarted";
import KHDataQualityPage from "./pages/KHDataQuality";
import KHReleasesPage from "./pages/KHReleases";
import { sustamizeLightTheme } from "./sustamize.theme";
import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import NavigationMenu from "./components/NavigationMenu";
import Footer from "./components/Footer";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import DatbaseOverviewPage from "./pages/KHDatabaseOverview";

function App() {
  return (
    <ThemeProvider theme={sustamizeLightTheme}>
      <CssBaseline />
      <Router>
        <div className="App min-h-screen flex flex-col">
          {/* Application Bar */}
          <ApplicationBar />

          {/* Main Content */}
          <div className="flex flex-grow md:flex-row" >
            {/* Navigation Menu */}
            <NavigationMenu />

            {/* Content Area */}
            <div className="flex-grow md:pl-64 overflow-x-hidden">
              <Routes>
                {/* Home Page Route */}
                <Route path="/" element={<HomePage />} />

                {/* File List Page Route */}
                <Route
                  path="/database-search"
                  element={<DatabaseSearchPage />}
                />

                {/* Knowledge Hub Pages */}
                <Route
                  path="/knowledge-hub/getting-started/:section"
                  element={<GettingStartedPage />}
                />
                <Route
                  path="/knowledge-hub/faq/:section"
                  element={<FAQPage />}
                />

                <Route
                  path="/knowledge-hub/database-overview/:section"
                  element={<DatbaseOverviewPage />}
                />
                <Route
                  path="/knowledge-hub/data-quality"
                  element={<KHDataQualityPage />}
                />
                <Route
                  path="/knowledge-hub/toolbox/:section"
                  element={<ToolboxPage />}
                />
                <Route
                  path="/knowledge-hub/releases/:section"
                  element={<KHReleasesPage />}
                />

                {/* API Web Reference */}
                <Route
                  path="/api-web-reference/:section"
                  element={<APIWebReferenceOverviewPage />}
                />
                <Route
                  path="/api-web-reference/reference"
                  element={<APIWebReferenceReferencePage />}
                />
              </Routes>
            </div>
          </div>
          {/* Footer */}
          <footer className="md:ml-64">
            <Footer />
          </footer>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
